export const HTML = 'html';
export const CSS = 'css';
export const JAVASCRIPT = 'javascript';



// WEBPACK FOOTER //
// ./src/lib/cm-modes.js